<div class="logo">
  <img src="assets/images/icon-512.png" alt="Shutterflow">
  <p>{{'sidebar.title'|transloco}}</p>
</div>
